import { backendTypes } from '../actions/applicantActions';

export default (state = [], action) => {
  switch (action.type) {
    case backendTypes.Email_Format:
      return {
        ...state,
        Email_Format: action.payload,
      };
    case backendTypes.Load:
      return {
        ...state,
        vacancy: {
          ...state.vacancy,
          load: action.load,
        },
      };
    case backendTypes.VACANCY:
      return {
        ...state,
        vacancy: {
          ...state.vacancy,
          load: false,
          column: action.column,
        },
      };
    case backendTypes.Drag_Candidate_Organic:
      return {
        ...state,
        vacancy: {
          ...state.vacancy,
          load: false,
          column: action.column,
          candidates: action.candidates,
        },
      };
    case backendTypes.Drag_Candidate:
      return {
        ...state,
        vacancy: {
          ...state.vacancy,
          load: false,
          column: action.column,
        },
      };
    case backendTypes.GET_DATA:
      return {
        ...state,
        vacancy: {
          ...state.vacancy,
          load: false,
          candidates_Store: action.candidates_Store,
          candidates: action.candidates,
        },
      };
    case backendTypes.GET_DATA_Update:
      return {
        ...state,
        vacancy: {
          ...state.vacancy,
          candidates_Store: action.candidates_Store,
        },
      };
    case backendTypes.UPDATE_USER_COLUMN:
      return {
        ...state,
        vacancy: {
          ...state.vacancy,
          columns: {
            ...state.columns,
            [action.payload.columnID]: action.payload.data,
          },
          store: action.payload.store,
        },
      };
    case backendTypes.UPDATE_USER_DATA:
      return {
        ...state,
        vacancy: {
          ...state.vacancy,
          info: action.payload,
        },
      };
    case backendTypes.UPDATE_USER:
      if (action.idColumn !== 'canidates') {
        return {
          ...state,
          vacancy: {
            ...state.vacancy,
            columns: {
              ...action.column,
            },
            load: false,
          },
        };
      } else {
        return {
          ...state,
          vacancy: {
            ...state.vacancy,
            canidates: [...action.column],
            load: false,
          },
        };
      }
    case backendTypes.SELEC_CANDIDATE:
      return {
        ...state,
        vacancy: {
          ...state.vacancy,
          info: action.payload,
        },
      };

    case backendTypes.POST_COMENTS:
      if (action.id === 'canidate') {
        return {
          ...state,
          vacancy: {
            ...state.vacancy,
            canidates: action.data,
          },
        };
      } else {
        return {
          ...state,
          vacancy: {
            ...state.vacancy,
            columns: {
              ...state.columns,
              [action.id]: action.data,
            },
          },
        };
      }
    case backendTypes.Column_CHECK_Candidate:
      return {
        ...state,
        vacancy: {
          ...state.vacancy,
          Check_Candidate: action.check_C,
        },
      };
    case backendTypes.getActivity:
      return {
        ...state,
        vacancy: {
          ...state.vacancy,
          activity: action.activity,
        },
      };

    default:
      return state;
  }
};
